
/**
 * ReInit Yotpo Star widget.
 */
{
    window.reinitYotpo = () => {
        let yotpoInterval = setInterval(() => {
            if(window.yotpoWidgetsContainer){
                setTimeout(() => {
                    // window.yotpoWidgetsContainer.initWidgets();
                    if(typeof window.yotpoWidgetsContainer.initWidget == "function"){
                        document.querySelectorAll('.yotpo-widget-instance:not([data-yotpo-element-loaded])').forEach(element => {
                            window.yotpoWidgetsContainer.initWidget(element.dataset.yotpoInstanceId,element);
                        });
                        clearInterval(yotpoInterval);
                    }
                }, 500);
            }
            /*if(window.yotpo){
                setTimeout(() => {
                    window.yotpo.initWidgets();
                    clearInterval(yotpoInterval);
                }, 500);
            }*/
        }, 500);

    };

    window.reinitYotpo();
}

